import { render } from "./HomeWithAuth.vue?vue&type=template&id=42434a7e&ts=true"
import script from "./HomeWithAuth.vue?vue&type=script&lang=ts"
export * from "./HomeWithAuth.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__